import {
  Entity,
  PrimaryKey,
  Property,
  Unique,
  ManyToOne,
  Rel,
} from '@mikro-orm/core';
import { Program } from './program.entity';

@Entity({ tableName: 'program_types' })
export class ProgramType {
  @PrimaryKey()
  id!: number;

  @Property({ type: 'varchar', length: 150 })
  @Unique()
  name!: string;

  @Property({ type: 'varchar', length: 150, nullable: true })
  slug?: string | null;

  @Property({ type: 'datetime' })
  created_at: Date = new Date();

  @Property({ type: 'datetime', onUpdate: () => new Date() })
  updated_at?: Date = new Date();

  @Property({ type: 'datetime', nullable: true })
  deleted_at?: Date | null = null;

  @ManyToOne(() => Program)
  program!: Rel<Program>;
}
